import LunchFoodsComponent from "../../../NonMVPComponents/Recipes/Lunch/LunchFoodsComponent";

const LunchFoods = () => {
  return (
    <div>
      <LunchFoodsComponent />
    </div>
  );
};

export default LunchFoods;
